import { render, staticRenderFns } from "./StoreCouponComponent.vue?vue&type=template&id=92be3046&scoped=true"
import script from "./StoreCouponComponent.vue?vue&type=script&lang=js"
export * from "./StoreCouponComponent.vue?vue&type=script&lang=js"
import style0 from "./StoreCouponComponent.vue?vue&type=style&index=0&id=92be3046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92be3046",
  null
  
)

export default component.exports